import { useEffect, useState } from 'react';
import { ensureAnonymousAuth, registerPushToken } from '../../common/anonymousAuth';

export const AppInitializer = ({ children }) => {
  const [ready, setReady] = useState(!!localStorage.getItem('userAuthToken'));

  useEffect(() => {
    if (ready) {
      registerPushToken();
      return;
    }

    ensureAnonymousAuth().then(() => {
      registerPushToken();
      setReady(true);
    });
  }, [ready]);

  if (!ready) return null;

  return children;
};
